import React from 'react';
import { FileMetadata } from '@/services/apis/files';
import { VideoStepView } from '@/components/guide-builder/VideoStepEditorForm';

interface VideoStepProps {
  content?: {
    video?: FileMetadata;
  };
  title?: string;
}

const VideoStep: React.FC<VideoStepProps> = ({ content, title }) => {
  if (!content?.video) {
    return <div className="text-center text-gray-500 dark:text-gray-400 py-8">No video available</div>;
  }

  return <VideoStepView fileMetadata={content.video} title={title} />;
};

export default VideoStep;
